import * as React from 'react'
import Message from 'src/packages/message/Message'
import Button from 'src/packages/button/Button'
import Code from 'src/components/Code'
import CodeBox from 'src/components/CodeBox'
import { renderString } from 'src/utils/renderCode'

const componentName = 'MessageExample'

class MessageExample extends React.Component {
  public static displayName = componentName

  public handleInfo = () => {
    Message.info({
      content: 'This is a message of info'
    })
  }

  public handleSuccess = () => {
    Message.success({
      content: 'This is a message of success',
      top: 50
    })
  }

  public handleWarning = () => {
    Message.warning({
      content: 'This is a message of warning',
      top: 100,
      duration: 5
    })
  }

  public handleError = () => {
    Message.error({
      content: 'This is a message of error',
      top: 150,
      duration: 0
    })
  }

  public render() {
    return (
      <div className="message-example">
        <section>
          <h1>Message 全局提示</h1>
          <p className="text">全局展示反馈信息。</p>
        </section>
        <section>
          <h2>何时使用</h2>
          <p className="text">需要一种不打断用户的轻量级提示方式时。</p>
        </section>
        <section>
          <h2>代码示例</h2>
        </section>
        <div className="example">
          <div className="container">
            <Button onClick={this.handleInfo} style={{ marginRight: '10px' }}>
              Info
            </Button>
            <Button
              onClick={this.handleSuccess}
              style={{ marginRight: '10px' }}
            >
              Success
            </Button>
            <Button
              onClick={this.handleWarning}
              style={{ marginRight: '10px' }}
            >
              Warning
            </Button>
            <Button onClick={this.handleError}>Error</Button>
          </div>
          <CodeBox
            title="基本用法"
            description="通过调用 Message 的静态方法：info()、success()、warning()、error() 并传递 options 参数来使用。具体属性设置见 Options。"
          >
            {renderString(`import { Message } from 'xue-react'`)}
            <br />
            <Code
              code={`&lt;Button onClick={this.handleInfo}&gt;Info&lt;/Button&gt;`}
            />
            <Code
              code={`&lt;Button onClick={this.handleSuccess}&gt;Success&lt;/Button&gt;`}
            />
            <Code
              code={`&lt;Button onClick={this.handleWarning}&gt;Warning&lt;/Button&gt;`}
            />
            <Code
              code={`&lt;Button onClick={this.handleError}&gt;Error&lt;/Button&gt;`}
            />
          </CodeBox>
        </div>
        <section>
          <h2>Options</h2>
        </section>
        <table className="api-table">
          <thead>
            <tr>
              <th>属性</th>
              <th className="des">说明</th>
              <th className="type">类型</th>
              <th>默认值</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>content</td>
              <td className="des">内容</td>
              <td className="type">string | ReactNode</td>
              <td>——</td>
            </tr>
            <tr>
              <td>duration</td>
              <td className="des">
                自动关闭的延时，单位：秒。设为 0 时不自动关闭
              </td>
              <td className="type">number</td>
              <td>0</td>
            </tr>
            <tr>
              <td>top</td>
              <td className="des">消息距离顶部的位置</td>
              <td className="type">number</td>
              <td>24</td>
            </tr>
            <tr>
              <td>showIcon</td>
              <td className="des">是否显示默认的提示 Icon 图标</td>
              <td className="type">boolean</td>
              <td>true</td>
            </tr>
            <tr>
              <td>onClose</td>
              <td className="des">消息完全关闭（离场动画结束）时的回调</td>
              <td className="type">() => any</td>
              <td>——</td>
            </tr>
            <tr>
              <td>className</td>
              <td className="des">自定义 Message 类名</td>
              <td className="type">string</td>
              <td>——</td>
            </tr>
            <tr>
              <td>style</td>
              <td className="des">自定义 Message 样式</td>
              <td className="type">React.CSSProperties</td>
              <td>——</td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default MessageExample



// WEBPACK FOOTER //
// ./src/examples/Message.example.tsx